/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { KTSVG } from '../../../../../_metronic/helpers'
import { SearchInputV3 } from '../../../components/SearchInputV3'
import { Loading } from '../../../components/Loadings/loading'
import listLayoutStyles from '../../../components/ListTableLayout/listTableLayout.module.css'
import { ModalAddUpdateTag } from '../ModalAddEditTag'
import { ModalDeleteTag } from '../ModalDeleteTag'
import { TableBody } from './TableBody'

type Props = {
  className: string
  tags: any[]
  refresh: any
  setFilterName: (value: string) => void
  loading: boolean
}

const TableTags: React.FC<Props> = ({
  className,
  tags,
  refresh,
  setFilterName,
  loading,
}) => {
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [showCreateAppModalDelete, setShowCreateAppModalDelete] = useState<boolean>(false)
  const [myTag, setMyTag] = useState<any | null>(null)

  return (
    <div className={`card ${className} ${listLayoutStyles.listCard}`}>
      <div className={`border-0 ${listLayoutStyles.listCardHeader}`} style={{padding: '1.25rem 1.25rem 0'}}>
        <div className={`${listLayoutStyles.listToolbar} ${listLayoutStyles.listToolbarPanel}`}>
          <div className={listLayoutStyles.listToolbarFilters}>
            <SearchInputV3
              className={`form-control form-control-sm ${listLayoutStyles.listSearch}`}
              placeholder='Buscar tag'
              setMySearch={setFilterName}
              style={{width: '100%'}}
            />
          </div>

          <div
            className={`card-toolbar ${listLayoutStyles.listToolbarActions}`}
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click para criar uma tag'
          >
            <a
              onClick={(event) => {
                event.preventDefault()
                setMyTag(null)
                setShowCreateAppModal(true)
              }}
              href='#'
              className='btn btn-sm btn-light-primary'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Nova Tag
            </a>
          </div>
        </div>
      </div>

      <div className={`card-body py-3 ${listLayoutStyles.listTablePanel}`}>
        <div className={`table-responsive ${listLayoutStyles.listTableWrap}`}>
          <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bolder text-muted fs-7 text-uppercase gs-0'>
                <th className='min-w-200px'>Tag</th>
                <th className='min-w-150px'>Tipo</th>
                <th className='min-w-150px'>Usinas vinculadas</th>
                <th className='min-w-100px'>Status</th>
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {loading ? (
              <tbody>
                <tr>
                  <td colSpan={5}>
                    <div className='d-flex justify-content-center py-10'>
                      <Loading myClass='spinner-border' />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <TableBody
                tags={tags}
                setMyTag={setMyTag}
                setShowCreateAppModal={setShowCreateAppModal}
                setShowCreateAppModalDelete={setShowCreateAppModalDelete}
              />
            )}
          </table>
        </div>
      </div>

      <ModalAddUpdateTag
        show={showCreateAppModal}
        id={myTag ? myTag.id : undefined}
        data={myTag ? myTag : undefined}
        handleClose={() => {
          setMyTag(null)
          setShowCreateAppModal(false)
          refresh()
        }}
      />
      <ModalDeleteTag
        show={showCreateAppModalDelete}
        id={myTag ? myTag.id : undefined}
        data={myTag ? myTag : undefined}
        handleClose={() => {
          setMyTag(null)
          setShowCreateAppModalDelete(false)
          refresh()
        }}
      />
    </div>
  )
}

export {TableTags}
